import type { FetchResult } from '@apollo/client';
import { gql } from '@apollo/client';
import { internalApiAppClient } from './apolloClient';
import type { QueryGiftCardConfig } from './getProjectsGql';
import { operationNames } from './index';

const requestGiftCardIssueAmountGql = gql`
  mutation ${operationNames.REQUEST_GIFT_CARD_ISSUE_AMOUNT}($issueAmount: Int!, $urlCode: String!) {
    requestGiftCardIssueAmount(
      input: {
        bulkGiftCardIssueConfigUrlCode: $urlCode
        issueAmount: $issueAmount
      }
    ) {
      giftCardConfig {
        urlCode
      }
    }
  }
`;

type RequestGiftCardIssueAmountResponse = FetchResult<{
  requestGiftIssueAmount: {
    giftCardConfig: QueryGiftCardConfig;
  };
}>;

export const requestGiftCardIssueAmount = (
  issueAmount: number,
  urlCode: string
): Promise<RequestGiftCardIssueAmountResponse> =>
  internalApiAppClient.mutate({
    mutation: requestGiftCardIssueAmountGql,
    variables: {
      issueAmount,
      urlCode
    }
  });
